module.exports = __webpack_public_path__ + "f961b4f7dca62f79184b8b1a5ba7fffd.svg";